import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'

const initialState = {
    workStatuses: [],
    initialDefaultWorkStatus: {},
    defaultWorkStatusPlanningData: {}
}

export default handleActions({
    [ActionTypes.WORK_STATUSES_SET]: (state, {payload: workStatuses}) => ({
        ...state,
        workStatuses,
    }),
    [ActionTypes.DEFAULT_WORK_STATUS_PLANNING_DATA_SET]: (state, {payload: defaultWorkStatusPlanningData}) => ({
        ...state,
        defaultWorkStatusPlanningData,
    }),
    [ActionTypes.INITIAL_DEFAULT_WORK_STATUS_SET]: (state, {payload: initialDefaultWorkStatus}) => ({
        ...state,
        initialDefaultWorkStatus,
    }),
}, initialState)



// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/workStatuses/reducer.js